"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrpcWebImpl = exports.MsgSQLAnalyzerDesc = exports.MsgSQLGrantDesc = exports.MsgSQLExecDesc = exports.MsgManageDocDesc = exports.MsgManageSchemaDesc = exports.MsgDesc = exports.MsgClientImpl = exports.SQLAnalyzerResponse = exports.Analyzer = exports.Tokenizer = exports.TokenFilter = exports.SQLAnalyzerRequest = exports.SQLGrantResponse = exports.SQLGrantRequest = exports.SQLExecResponse = exports.SQLExecRequest = exports.MsgDocResponse = exports.MsgDoc = exports.MsgSchemaResponse = exports.MsgSchema = exports.opTypeToJSON = exports.opTypeFromJSON = exports.OpType = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const grpc_web_1 = require("@improbable-eng/grpc-web");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const browser_headers_1 = require("browser-headers");
const sql_engine_1 = require("../index/sql_engine");
exports.protobufPackage = "blockved.glitterchain.index";
var OpType;
(function (OpType) {
    OpType[OpType["Create"] = 0] = "Create";
    OpType[OpType["Update"] = 1] = "Update";
    OpType[OpType["Delete"] = 2] = "Delete";
    OpType[OpType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(OpType = exports.OpType || (exports.OpType = {}));
function opTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "Create":
            return OpType.Create;
        case 1:
        case "Update":
            return OpType.Update;
        case 2:
        case "Delete":
            return OpType.Delete;
        case -1:
        case "UNRECOGNIZED":
        default:
            return OpType.UNRECOGNIZED;
    }
}
exports.opTypeFromJSON = opTypeFromJSON;
function opTypeToJSON(object) {
    switch (object) {
        case OpType.Create:
            return "Create";
        case OpType.Update:
            return "Update";
        case OpType.Delete:
            return "Delete";
        default:
            return "UNKNOWN";
    }
}
exports.opTypeToJSON = opTypeToJSON;
const baseMsgSchema = { ownerAddress: "", schemaName: "", body: "" };
exports.MsgSchema = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.ownerAddress !== "") {
            writer.uint32(10).string(message.ownerAddress);
        }
        if (message.schemaName !== "") {
            writer.uint32(18).string(message.schemaName);
        }
        if (message.body !== "") {
            writer.uint32(26).string(message.body);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSchema);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ownerAddress = reader.string();
                    break;
                case 2:
                    message.schemaName = reader.string();
                    break;
                case 3:
                    message.body = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSchema);
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = String(object.ownerAddress);
        }
        else {
            message.ownerAddress = "";
        }
        if (object.schemaName !== undefined && object.schemaName !== null) {
            message.schemaName = String(object.schemaName);
        }
        else {
            message.schemaName = "";
        }
        if (object.body !== undefined && object.body !== null) {
            message.body = String(object.body);
        }
        else {
            message.body = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.ownerAddress !== undefined && (obj.ownerAddress = message.ownerAddress);
        message.schemaName !== undefined && (obj.schemaName = message.schemaName);
        message.body !== undefined && (obj.body = message.body);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgSchema);
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = object.ownerAddress;
        }
        else {
            message.ownerAddress = "";
        }
        if (object.schemaName !== undefined && object.schemaName !== null) {
            message.schemaName = object.schemaName;
        }
        else {
            message.schemaName = "";
        }
        if (object.body !== undefined && object.body !== null) {
            message.body = object.body;
        }
        else {
            message.body = "";
        }
        return message;
    },
};
const baseMsgSchemaResponse = {};
exports.MsgSchemaResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSchemaResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSchemaResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSchemaResponse);
        return message;
    },
};
const baseMsgDoc = { ownerAddress: "", schemaName: "", body: "" };
exports.MsgDoc = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.ownerAddress !== "") {
            writer.uint32(10).string(message.ownerAddress);
        }
        if (message.schemaName !== "") {
            writer.uint32(18).string(message.schemaName);
        }
        if (message.body !== "") {
            writer.uint32(26).string(message.body);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDoc);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ownerAddress = reader.string();
                    break;
                case 2:
                    message.schemaName = reader.string();
                    break;
                case 3:
                    message.body = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgDoc);
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = String(object.ownerAddress);
        }
        else {
            message.ownerAddress = "";
        }
        if (object.schemaName !== undefined && object.schemaName !== null) {
            message.schemaName = String(object.schemaName);
        }
        else {
            message.schemaName = "";
        }
        if (object.body !== undefined && object.body !== null) {
            message.body = String(object.body);
        }
        else {
            message.body = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.ownerAddress !== undefined && (obj.ownerAddress = message.ownerAddress);
        message.schemaName !== undefined && (obj.schemaName = message.schemaName);
        message.body !== undefined && (obj.body = message.body);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgDoc);
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = object.ownerAddress;
        }
        else {
            message.ownerAddress = "";
        }
        if (object.schemaName !== undefined && object.schemaName !== null) {
            message.schemaName = object.schemaName;
        }
        else {
            message.schemaName = "";
        }
        if (object.body !== undefined && object.body !== null) {
            message.body = object.body;
        }
        else {
            message.body = "";
        }
        return message;
    },
};
const baseMsgDocResponse = {};
exports.MsgDocResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDocResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgDocResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgDocResponse);
        return message;
    },
};
const baseSQLExecRequest = { uid: "", sql: "" };
exports.SQLExecRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.uid !== "") {
            writer.uint32(10).string(message.uid);
        }
        if (message.sql !== "") {
            writer.uint32(18).string(message.sql);
        }
        for (const v of message.arguments) {
            sql_engine_1.Argument.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSQLExecRequest);
        message.arguments = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.uid = reader.string();
                    break;
                case 2:
                    message.sql = reader.string();
                    break;
                case 3:
                    message.arguments.push(sql_engine_1.Argument.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSQLExecRequest);
        message.arguments = [];
        if (object.uid !== undefined && object.uid !== null) {
            message.uid = String(object.uid);
        }
        else {
            message.uid = "";
        }
        if (object.sql !== undefined && object.sql !== null) {
            message.sql = String(object.sql);
        }
        else {
            message.sql = "";
        }
        if (object.arguments !== undefined && object.arguments !== null) {
            for (const e of object.arguments) {
                message.arguments.push(sql_engine_1.Argument.fromJSON(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.uid !== undefined && (obj.uid = message.uid);
        message.sql !== undefined && (obj.sql = message.sql);
        if (message.arguments) {
            obj.arguments = message.arguments.map((e) => (e ? sql_engine_1.Argument.toJSON(e) : undefined));
        }
        else {
            obj.arguments = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSQLExecRequest);
        message.arguments = [];
        if (object.uid !== undefined && object.uid !== null) {
            message.uid = object.uid;
        }
        else {
            message.uid = "";
        }
        if (object.sql !== undefined && object.sql !== null) {
            message.sql = object.sql;
        }
        else {
            message.sql = "";
        }
        if (object.arguments !== undefined && object.arguments !== null) {
            for (const e of object.arguments) {
                message.arguments.push(sql_engine_1.Argument.fromPartial(e));
            }
        }
        return message;
    },
};
const baseSQLExecResponse = { tookTimes: 0 };
exports.SQLExecResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.results) {
            sql_engine_1.ResultSet.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.tookTimes !== 0) {
            writer.uint32(21).float(message.tookTimes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSQLExecResponse);
        message.results = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.results.push(sql_engine_1.ResultSet.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.tookTimes = reader.float();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSQLExecResponse);
        message.results = [];
        if (object.results !== undefined && object.results !== null) {
            for (const e of object.results) {
                message.results.push(sql_engine_1.ResultSet.fromJSON(e));
            }
        }
        if (object.tookTimes !== undefined && object.tookTimes !== null) {
            message.tookTimes = Number(object.tookTimes);
        }
        else {
            message.tookTimes = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.results) {
            obj.results = message.results.map((e) => (e ? sql_engine_1.ResultSet.toJSON(e) : undefined));
        }
        else {
            obj.results = [];
        }
        message.tookTimes !== undefined && (obj.tookTimes = message.tookTimes);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSQLExecResponse);
        message.results = [];
        if (object.results !== undefined && object.results !== null) {
            for (const e of object.results) {
                message.results.push(sql_engine_1.ResultSet.fromPartial(e));
            }
        }
        if (object.tookTimes !== undefined && object.tookTimes !== null) {
            message.tookTimes = object.tookTimes;
        }
        else {
            message.tookTimes = 0;
        }
        return message;
    },
};
const baseSQLGrantRequest = { uid: "", onTable: "", toUID: "", role: "", onDatabase: "" };
exports.SQLGrantRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.uid !== "") {
            writer.uint32(10).string(message.uid);
        }
        if (message.onTable !== "") {
            writer.uint32(18).string(message.onTable);
        }
        if (message.toUID !== "") {
            writer.uint32(26).string(message.toUID);
        }
        if (message.role !== "") {
            writer.uint32(34).string(message.role);
        }
        if (message.onDatabase !== "") {
            writer.uint32(42).string(message.onDatabase);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSQLGrantRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.uid = reader.string();
                    break;
                case 2:
                    message.onTable = reader.string();
                    break;
                case 3:
                    message.toUID = reader.string();
                    break;
                case 4:
                    message.role = reader.string();
                    break;
                case 5:
                    message.onDatabase = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSQLGrantRequest);
        if (object.uid !== undefined && object.uid !== null) {
            message.uid = String(object.uid);
        }
        else {
            message.uid = "";
        }
        if (object.onTable !== undefined && object.onTable !== null) {
            message.onTable = String(object.onTable);
        }
        else {
            message.onTable = "";
        }
        if (object.toUID !== undefined && object.toUID !== null) {
            message.toUID = String(object.toUID);
        }
        else {
            message.toUID = "";
        }
        if (object.role !== undefined && object.role !== null) {
            message.role = String(object.role);
        }
        else {
            message.role = "";
        }
        if (object.onDatabase !== undefined && object.onDatabase !== null) {
            message.onDatabase = String(object.onDatabase);
        }
        else {
            message.onDatabase = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.uid !== undefined && (obj.uid = message.uid);
        message.onTable !== undefined && (obj.onTable = message.onTable);
        message.toUID !== undefined && (obj.toUID = message.toUID);
        message.role !== undefined && (obj.role = message.role);
        message.onDatabase !== undefined && (obj.onDatabase = message.onDatabase);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSQLGrantRequest);
        if (object.uid !== undefined && object.uid !== null) {
            message.uid = object.uid;
        }
        else {
            message.uid = "";
        }
        if (object.onTable !== undefined && object.onTable !== null) {
            message.onTable = object.onTable;
        }
        else {
            message.onTable = "";
        }
        if (object.toUID !== undefined && object.toUID !== null) {
            message.toUID = object.toUID;
        }
        else {
            message.toUID = "";
        }
        if (object.role !== undefined && object.role !== null) {
            message.role = object.role;
        }
        else {
            message.role = "";
        }
        if (object.onDatabase !== undefined && object.onDatabase !== null) {
            message.onDatabase = object.onDatabase;
        }
        else {
            message.onDatabase = "";
        }
        return message;
    },
};
const baseSQLGrantResponse = {};
exports.SQLGrantResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSQLGrantResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseSQLGrantResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseSQLGrantResponse);
        return message;
    },
};
const baseSQLAnalyzerRequest = { uid: "", analysisType: "", opType: 0 };
exports.SQLAnalyzerRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.uid !== "") {
            writer.uint32(10).string(message.uid);
        }
        if (message.analysisType !== "") {
            writer.uint32(18).string(message.analysisType);
        }
        if (message.opType !== 0) {
            writer.uint32(24).int32(message.opType);
        }
        if (message.tokenFilter !== undefined) {
            exports.TokenFilter.encode(message.tokenFilter, writer.uint32(34).fork()).ldelim();
        }
        if (message.tokenizer !== undefined) {
            exports.Tokenizer.encode(message.tokenizer, writer.uint32(42).fork()).ldelim();
        }
        if (message.analyzer !== undefined) {
            exports.Analyzer.encode(message.analyzer, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSQLAnalyzerRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.uid = reader.string();
                    break;
                case 2:
                    message.analysisType = reader.string();
                    break;
                case 3:
                    message.opType = reader.int32();
                    break;
                case 4:
                    message.tokenFilter = exports.TokenFilter.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.tokenizer = exports.Tokenizer.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.analyzer = exports.Analyzer.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSQLAnalyzerRequest);
        if (object.uid !== undefined && object.uid !== null) {
            message.uid = String(object.uid);
        }
        else {
            message.uid = "";
        }
        if (object.analysisType !== undefined && object.analysisType !== null) {
            message.analysisType = String(object.analysisType);
        }
        else {
            message.analysisType = "";
        }
        if (object.opType !== undefined && object.opType !== null) {
            message.opType = opTypeFromJSON(object.opType);
        }
        else {
            message.opType = 0;
        }
        if (object.tokenFilter !== undefined && object.tokenFilter !== null) {
            message.tokenFilter = exports.TokenFilter.fromJSON(object.tokenFilter);
        }
        else {
            message.tokenFilter = undefined;
        }
        if (object.tokenizer !== undefined && object.tokenizer !== null) {
            message.tokenizer = exports.Tokenizer.fromJSON(object.tokenizer);
        }
        else {
            message.tokenizer = undefined;
        }
        if (object.analyzer !== undefined && object.analyzer !== null) {
            message.analyzer = exports.Analyzer.fromJSON(object.analyzer);
        }
        else {
            message.analyzer = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.uid !== undefined && (obj.uid = message.uid);
        message.analysisType !== undefined && (obj.analysisType = message.analysisType);
        message.opType !== undefined && (obj.opType = opTypeToJSON(message.opType));
        message.tokenFilter !== undefined &&
            (obj.tokenFilter = message.tokenFilter ? exports.TokenFilter.toJSON(message.tokenFilter) : undefined);
        message.tokenizer !== undefined &&
            (obj.tokenizer = message.tokenizer ? exports.Tokenizer.toJSON(message.tokenizer) : undefined);
        message.analyzer !== undefined &&
            (obj.analyzer = message.analyzer ? exports.Analyzer.toJSON(message.analyzer) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSQLAnalyzerRequest);
        if (object.uid !== undefined && object.uid !== null) {
            message.uid = object.uid;
        }
        else {
            message.uid = "";
        }
        if (object.analysisType !== undefined && object.analysisType !== null) {
            message.analysisType = object.analysisType;
        }
        else {
            message.analysisType = "";
        }
        if (object.opType !== undefined && object.opType !== null) {
            message.opType = object.opType;
        }
        else {
            message.opType = 0;
        }
        if (object.tokenFilter !== undefined && object.tokenFilter !== null) {
            message.tokenFilter = exports.TokenFilter.fromPartial(object.tokenFilter);
        }
        else {
            message.tokenFilter = undefined;
        }
        if (object.tokenizer !== undefined && object.tokenizer !== null) {
            message.tokenizer = exports.Tokenizer.fromPartial(object.tokenizer);
        }
        else {
            message.tokenizer = undefined;
        }
        if (object.analyzer !== undefined && object.analyzer !== null) {
            message.analyzer = exports.Analyzer.fromPartial(object.analyzer);
        }
        else {
            message.analyzer = undefined;
        }
        return message;
    },
};
const baseTokenFilter = {
    tokenFilterName: "",
    tokenFilterEnName: "",
    tokenFilterType: 0,
    dictFileCid: "",
    comment: "",
};
exports.TokenFilter = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tokenFilterName !== "") {
            writer.uint32(10).string(message.tokenFilterName);
        }
        if (message.tokenFilterEnName !== "") {
            writer.uint32(18).string(message.tokenFilterEnName);
        }
        if (message.tokenFilterType !== 0) {
            writer.uint32(24).int32(message.tokenFilterType);
        }
        if (message.dictFileCid !== "") {
            writer.uint32(34).string(message.dictFileCid);
        }
        if (message.comment !== "") {
            writer.uint32(42).string(message.comment);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseTokenFilter);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tokenFilterName = reader.string();
                    break;
                case 2:
                    message.tokenFilterEnName = reader.string();
                    break;
                case 3:
                    message.tokenFilterType = reader.int32();
                    break;
                case 4:
                    message.dictFileCid = reader.string();
                    break;
                case 5:
                    message.comment = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseTokenFilter);
        if (object.tokenFilterName !== undefined && object.tokenFilterName !== null) {
            message.tokenFilterName = String(object.tokenFilterName);
        }
        else {
            message.tokenFilterName = "";
        }
        if (object.tokenFilterEnName !== undefined && object.tokenFilterEnName !== null) {
            message.tokenFilterEnName = String(object.tokenFilterEnName);
        }
        else {
            message.tokenFilterEnName = "";
        }
        if (object.tokenFilterType !== undefined && object.tokenFilterType !== null) {
            message.tokenFilterType = Number(object.tokenFilterType);
        }
        else {
            message.tokenFilterType = 0;
        }
        if (object.dictFileCid !== undefined && object.dictFileCid !== null) {
            message.dictFileCid = String(object.dictFileCid);
        }
        else {
            message.dictFileCid = "";
        }
        if (object.comment !== undefined && object.comment !== null) {
            message.comment = String(object.comment);
        }
        else {
            message.comment = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.tokenFilterName !== undefined && (obj.tokenFilterName = message.tokenFilterName);
        message.tokenFilterEnName !== undefined && (obj.tokenFilterEnName = message.tokenFilterEnName);
        message.tokenFilterType !== undefined && (obj.tokenFilterType = message.tokenFilterType);
        message.dictFileCid !== undefined && (obj.dictFileCid = message.dictFileCid);
        message.comment !== undefined && (obj.comment = message.comment);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseTokenFilter);
        if (object.tokenFilterName !== undefined && object.tokenFilterName !== null) {
            message.tokenFilterName = object.tokenFilterName;
        }
        else {
            message.tokenFilterName = "";
        }
        if (object.tokenFilterEnName !== undefined && object.tokenFilterEnName !== null) {
            message.tokenFilterEnName = object.tokenFilterEnName;
        }
        else {
            message.tokenFilterEnName = "";
        }
        if (object.tokenFilterType !== undefined && object.tokenFilterType !== null) {
            message.tokenFilterType = object.tokenFilterType;
        }
        else {
            message.tokenFilterType = 0;
        }
        if (object.dictFileCid !== undefined && object.dictFileCid !== null) {
            message.dictFileCid = object.dictFileCid;
        }
        else {
            message.dictFileCid = "";
        }
        if (object.comment !== undefined && object.comment !== null) {
            message.comment = object.comment;
        }
        else {
            message.comment = "";
        }
        return message;
    },
};
const baseTokenizer = {
    tokenizerName: "",
    tokenizerEnName: "",
    tokenizerType: 0,
    dictFileCid: "",
    comment: "",
};
exports.Tokenizer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tokenizerName !== "") {
            writer.uint32(10).string(message.tokenizerName);
        }
        if (message.tokenizerEnName !== "") {
            writer.uint32(18).string(message.tokenizerEnName);
        }
        if (message.tokenizerType !== 0) {
            writer.uint32(24).int32(message.tokenizerType);
        }
        if (message.dictFileCid !== "") {
            writer.uint32(34).string(message.dictFileCid);
        }
        if (message.comment !== "") {
            writer.uint32(42).string(message.comment);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseTokenizer);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tokenizerName = reader.string();
                    break;
                case 2:
                    message.tokenizerEnName = reader.string();
                    break;
                case 3:
                    message.tokenizerType = reader.int32();
                    break;
                case 4:
                    message.dictFileCid = reader.string();
                    break;
                case 5:
                    message.comment = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseTokenizer);
        if (object.tokenizerName !== undefined && object.tokenizerName !== null) {
            message.tokenizerName = String(object.tokenizerName);
        }
        else {
            message.tokenizerName = "";
        }
        if (object.tokenizerEnName !== undefined && object.tokenizerEnName !== null) {
            message.tokenizerEnName = String(object.tokenizerEnName);
        }
        else {
            message.tokenizerEnName = "";
        }
        if (object.tokenizerType !== undefined && object.tokenizerType !== null) {
            message.tokenizerType = Number(object.tokenizerType);
        }
        else {
            message.tokenizerType = 0;
        }
        if (object.dictFileCid !== undefined && object.dictFileCid !== null) {
            message.dictFileCid = String(object.dictFileCid);
        }
        else {
            message.dictFileCid = "";
        }
        if (object.comment !== undefined && object.comment !== null) {
            message.comment = String(object.comment);
        }
        else {
            message.comment = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.tokenizerName !== undefined && (obj.tokenizerName = message.tokenizerName);
        message.tokenizerEnName !== undefined && (obj.tokenizerEnName = message.tokenizerEnName);
        message.tokenizerType !== undefined && (obj.tokenizerType = message.tokenizerType);
        message.dictFileCid !== undefined && (obj.dictFileCid = message.dictFileCid);
        message.comment !== undefined && (obj.comment = message.comment);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseTokenizer);
        if (object.tokenizerName !== undefined && object.tokenizerName !== null) {
            message.tokenizerName = object.tokenizerName;
        }
        else {
            message.tokenizerName = "";
        }
        if (object.tokenizerEnName !== undefined && object.tokenizerEnName !== null) {
            message.tokenizerEnName = object.tokenizerEnName;
        }
        else {
            message.tokenizerEnName = "";
        }
        if (object.tokenizerType !== undefined && object.tokenizerType !== null) {
            message.tokenizerType = object.tokenizerType;
        }
        else {
            message.tokenizerType = 0;
        }
        if (object.dictFileCid !== undefined && object.dictFileCid !== null) {
            message.dictFileCid = object.dictFileCid;
        }
        else {
            message.dictFileCid = "";
        }
        if (object.comment !== undefined && object.comment !== null) {
            message.comment = object.comment;
        }
        else {
            message.comment = "";
        }
        return message;
    },
};
const baseAnalyzer = {
    analyzerName: "",
    analyzerEnName: "",
    charFilters: "",
    tokenizer: "",
    tokenFilters: "",
    comment: "",
};
exports.Analyzer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.analyzerName !== "") {
            writer.uint32(10).string(message.analyzerName);
        }
        if (message.analyzerEnName !== "") {
            writer.uint32(18).string(message.analyzerEnName);
        }
        if (message.charFilters !== "") {
            writer.uint32(26).string(message.charFilters);
        }
        if (message.tokenizer !== "") {
            writer.uint32(34).string(message.tokenizer);
        }
        if (message.tokenFilters !== "") {
            writer.uint32(42).string(message.tokenFilters);
        }
        if (message.comment !== "") {
            writer.uint32(50).string(message.comment);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseAnalyzer);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.analyzerName = reader.string();
                    break;
                case 2:
                    message.analyzerEnName = reader.string();
                    break;
                case 3:
                    message.charFilters = reader.string();
                    break;
                case 4:
                    message.tokenizer = reader.string();
                    break;
                case 5:
                    message.tokenFilters = reader.string();
                    break;
                case 6:
                    message.comment = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseAnalyzer);
        if (object.analyzerName !== undefined && object.analyzerName !== null) {
            message.analyzerName = String(object.analyzerName);
        }
        else {
            message.analyzerName = "";
        }
        if (object.analyzerEnName !== undefined && object.analyzerEnName !== null) {
            message.analyzerEnName = String(object.analyzerEnName);
        }
        else {
            message.analyzerEnName = "";
        }
        if (object.charFilters !== undefined && object.charFilters !== null) {
            message.charFilters = String(object.charFilters);
        }
        else {
            message.charFilters = "";
        }
        if (object.tokenizer !== undefined && object.tokenizer !== null) {
            message.tokenizer = String(object.tokenizer);
        }
        else {
            message.tokenizer = "";
        }
        if (object.tokenFilters !== undefined && object.tokenFilters !== null) {
            message.tokenFilters = String(object.tokenFilters);
        }
        else {
            message.tokenFilters = "";
        }
        if (object.comment !== undefined && object.comment !== null) {
            message.comment = String(object.comment);
        }
        else {
            message.comment = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.analyzerName !== undefined && (obj.analyzerName = message.analyzerName);
        message.analyzerEnName !== undefined && (obj.analyzerEnName = message.analyzerEnName);
        message.charFilters !== undefined && (obj.charFilters = message.charFilters);
        message.tokenizer !== undefined && (obj.tokenizer = message.tokenizer);
        message.tokenFilters !== undefined && (obj.tokenFilters = message.tokenFilters);
        message.comment !== undefined && (obj.comment = message.comment);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseAnalyzer);
        if (object.analyzerName !== undefined && object.analyzerName !== null) {
            message.analyzerName = object.analyzerName;
        }
        else {
            message.analyzerName = "";
        }
        if (object.analyzerEnName !== undefined && object.analyzerEnName !== null) {
            message.analyzerEnName = object.analyzerEnName;
        }
        else {
            message.analyzerEnName = "";
        }
        if (object.charFilters !== undefined && object.charFilters !== null) {
            message.charFilters = object.charFilters;
        }
        else {
            message.charFilters = "";
        }
        if (object.tokenizer !== undefined && object.tokenizer !== null) {
            message.tokenizer = object.tokenizer;
        }
        else {
            message.tokenizer = "";
        }
        if (object.tokenFilters !== undefined && object.tokenFilters !== null) {
            message.tokenFilters = object.tokenFilters;
        }
        else {
            message.tokenFilters = "";
        }
        if (object.comment !== undefined && object.comment !== null) {
            message.comment = object.comment;
        }
        else {
            message.comment = "";
        }
        return message;
    },
};
const baseSQLAnalyzerResponse = {};
exports.SQLAnalyzerResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSQLAnalyzerResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseSQLAnalyzerResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseSQLAnalyzerResponse);
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.ManageSchema = this.ManageSchema.bind(this);
        this.ManageDoc = this.ManageDoc.bind(this);
        this.SQLExec = this.SQLExec.bind(this);
        this.SQLGrant = this.SQLGrant.bind(this);
        this.SQLAnalyzer = this.SQLAnalyzer.bind(this);
    }
    ManageSchema(request, metadata) {
        return this.rpc.unary(exports.MsgManageSchemaDesc, exports.MsgSchema.fromPartial(request), metadata);
    }
    ManageDoc(request, metadata) {
        return this.rpc.unary(exports.MsgManageDocDesc, exports.MsgDoc.fromPartial(request), metadata);
    }
    SQLExec(request, metadata) {
        return this.rpc.unary(exports.MsgSQLExecDesc, exports.SQLExecRequest.fromPartial(request), metadata);
    }
    SQLGrant(request, metadata) {
        return this.rpc.unary(exports.MsgSQLGrantDesc, exports.SQLGrantRequest.fromPartial(request), metadata);
    }
    SQLAnalyzer(request, metadata) {
        return this.rpc.unary(exports.MsgSQLAnalyzerDesc, exports.SQLAnalyzerRequest.fromPartial(request), metadata);
    }
}
exports.MsgClientImpl = MsgClientImpl;
exports.MsgDesc = {
    serviceName: "blockved.glitterchain.index.Msg",
};
exports.MsgManageSchemaDesc = {
    methodName: "ManageSchema",
    service: exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.MsgSchema.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.MsgSchemaResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
exports.MsgManageDocDesc = {
    methodName: "ManageDoc",
    service: exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.MsgDoc.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.MsgDocResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
exports.MsgSQLExecDesc = {
    methodName: "SQLExec",
    service: exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.SQLExecRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.SQLExecResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
exports.MsgSQLGrantDesc = {
    methodName: "SQLGrant",
    service: exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.SQLGrantRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.SQLGrantResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
exports.MsgSQLAnalyzerDesc = {
    methodName: "SQLAnalyzer",
    service: exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.SQLAnalyzerRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.SQLAnalyzerResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
class GrpcWebImpl {
    constructor(host, options) {
        this.host = host;
        this.options = options;
    }
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata
            ? new browser_headers_1.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap))
            : metadata || this.options.metadata;
        return new Promise((resolve, reject) => {
            grpc_web_1.grpc.unary(methodDesc, {
                request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function (response) {
                    if (response.status === grpc_web_1.grpc.Code.OK) {
                        resolve(response.message);
                    }
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                },
            });
        });
    }
}
exports.GrpcWebImpl = GrpcWebImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=tx.js.map